const PERM_NAMES = {
  9: 'Xem',
  10: 'Tạo mới',
  11: 'Cập nhật',
  12: 'Xóa',
  13: 'Gán dữ liệu',
};

let _router = null;
let _store = null;

/** Gọi 1 lần trong main.js sau khi khởi tạo router và store */
export function registerPermissionContext(router, store) {
  _router = router;
  _store = store;
}

function getStoredPermissions() {
  return (
    _store?.state?.auth?.permissions ||
    JSON.parse(localStorage.getItem('permissions') || '[]')
  );
}

function getUserPermsForPage(pageCode) {
  return (
    getStoredPermissions()
      .find((p) => p.code === pageCode)
      ?.value?.map((v) => v.nameType) || []
  );
}

function getPageName(route) {
  const breadcrumbs = route?.meta?.breadcrumb || [];
  const active =
    breadcrumbs.find((b) => b.active) || breadcrumbs[breadcrumbs.length - 1];
  return active?.name || route?.name || route?.meta?.pageCode || 'trang này';
}

function buildMessage(missingPerms, pageName) {
  if (!missingPerms.length)
    return 'Bạn không có quyền thực hiện chức năng này';
  const names = missingPerms.map((p) => PERM_NAMES[p] || String(p)).join(', ');
  return `Bạn thiếu quyền [${names}] tại "${pageName}"`;
}

function dispatch(message) {
  window.dispatchEvent(
    new CustomEvent('api:forbidden', { detail: { message } }),
  );
}

/**
 * Bản boolean của checkPermission - không toast, không throw.
 * Dùng cho v-if khi cần ẩn/hiện nút theo quyền.
 * @param {string} pageCode
 * @param {number|number[]} requiredPerms - 1 permType hoặc mảng permType, cần có ít nhất 1
 */
export function hasPermission(pageCode, requiredPerms = []) {
  const userPerms = getUserPermsForPage(pageCode);
  const required = Array.isArray(requiredPerms) ? requiredPerms : [requiredPerms];
  return required.some((p) => userPerms.includes(p));
}

/**
 * Kiểm tra permission cho pageCode + danh sách permType cần thiết.
 * Nếu thiếu → hiện toast + throw.
 * @param {string} pageCode
 * @param {number[]} requiredPerms - mảng PERMISSION_TYPE cần có ít nhất 1
 */
export function checkPermission(pageCode, requiredPerms = []) {
  const userPerms = getUserPermsForPage(pageCode);
  const hasAny = requiredPerms.some((p) => userPerms.includes(p));
  if (!hasAny) {
    const missing = requiredPerms.filter((p) => !userPerms.includes(p));
    const route = _router?.currentRoute;
    const msg = buildMessage(missing, getPageName(route));
    dispatch(msg);
    const err = new Error(msg);
    err.code = 'access_denied';
    throw err;
  }
}

/**
 * Tự động detect pageCode từ current route.
 * Dùng khi component không muốn truyền pageCode thủ công.
 * @param {number} permType - 1 PERMISSION_TYPE cụ thể cần check
 */
export function checkCurrentRoutePermission(permType) {
  const route = _router?.currentRoute;
  const pageCode = route?.meta?.pageCode;
  if (!pageCode) return;
  checkPermission(pageCode, [permType]);
}

/**
 * Dùng trong interceptor khi nhận 401/403 từ BE.
 * Tự tìm pageCode từ current route, so sánh với quyền user có.
 */
export function buildForbiddenMessage() {
  try {
    const route = _router?.currentRoute;
    const { pageCode, permissions: required } = route?.meta || {};
    const pageName = getPageName(route);

    if (pageCode && required?.length) {
      const userPerms = getUserPermsForPage(pageCode);
      const missing = required.filter((p) => !userPerms.includes(p));
      if (missing.length) {
        return buildMessage(missing, pageName);
      }
    }
  } catch (_) {
    // ignore
  }
  return 'Bạn không có quyền thực hiện chức năng này';
}
